import { React } from "react";
//import { useSpring, animated } from "react-spring";
import "./uppertopbar.css";

export default function HAnimation() {
  //const [flip, set] = useState(false);
  //const props = useSpring({
  //to: { opacity: 1 },
  //from: { opacity: 0.05 },
  //reset: true,
  // reverse: flip,
  //delay: 200,
  //onRest: () => set(!flip),
  //});

  return (
    <div className="animation">
      <div>WELCOME TO</div>
      <div className="companyname"> LAFEMA </div>
      <div> SYSTEMS</div>
    </div>
  );
}
